module.exports = __webpack_public_path__ + "static/media/navidad11.91b9c0a9.jpg";